import { useEffect } from 'react';
import { COMPACT_HEADER_QUERY } from '../headerConstants';

/**
 * Calls `close` when the window grows past the compact breakpoint: the menu
 * is a portal, so hiding its button alone would leave it open on screen.
 */
export const useCloseAboveCompact = (close) => {
    useEffect(() => {
        const compact = window.matchMedia(COMPACT_HEADER_QUERY);
        const handleChange = (event) => {
            if (!event.matches) close();
        };
        compact.addEventListener('change', handleChange);
        return () => compact.removeEventListener('change', handleChange);
    }, [close]);
};
